import { render } from "./conversation.vue?vue&type=template&id=1c5bddf9"
import script from "./conversation.js?vue&type=script&lang=js"
export * from "./conversation.js?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=1c5bddf9&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__